import { useQuery } from '@hooks/reactQuery';

import { getPortalFolders } from '@api/portalFiles';

import { extractQueryParams } from '@utils/common';

import { IPortalFolder } from '@interfaces/portal/folders';

import { GET_PORTAL_FOLDERS } from '@constants/queryKeys';

interface IUseQueryPortalFoldersReturned {
	isLoadingPortalFolders: boolean;
	portalFolders: Array<IPortalFolder>;
	defaultFolderId: string | null;
}

interface IUseQueryPortalFolders {
	projectId?: string;
	searchValue: string;
	milestoneIds: string[] | null;
}

export const useQueryPortalFolders = ({
	projectId,
	searchValue,
	milestoneIds,
}: IUseQueryPortalFolders): IUseQueryPortalFoldersReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery<IPortalFolder[]>({
			queryKey: [
				GET_PORTAL_FOLDERS,
				{
					searchValue,
					projectId,
					milestoneIds,
				},
			],
			queryFn: extractQueryParams(getPortalFolders),
			enabled: [!!projectId],
			refetchOnReconnect: false,
			refetchOnWindowFocus: false,
			refetchOnMount: true,
			staleTime: 0,
		},
	);

	return {
		isLoadingPortalFolders: isInitialLoading,
		portalFolders: data || [],
		defaultFolderId: data?.[0]?.id || null,
	};
};
